export default {
  default: () => import("/home/vsts/work/1/s/src/layouts/default.vue").then(m => m.default || m)
}